import { useEffect } from 'react';
import Link from 'next/link';
import { FaFileAudio, FaFilePdf } from 'react-icons/fa';
import ImageWithFallback from '@/Component/Common/ImageWithFallback';

const OtherAttachments = (props) => {
    const { attachmentData, userDetails, setOtherAttachments } = props;

    useEffect(() => {
        setOtherAttachments(attachmentData);
    }, [attachmentData]);

    return (
        <div className='grid grid-cols-4 gap-4 mt-2.5 items-start'>
            {attachmentData?.map((item, index) => (
                <div className="aspect-square bg-gray/25 h-max" key={index}>
                    {item?.fileType?.includes('image') ?
                        <Link href={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} target="_blank" rel="noreferrer" className="flex items-center justify-center w-full h-full">
                            <ImageWithFallback src={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} alt='Profile' className='w-full h-full object-cover' height={70} width={70} />
                            {/* <FaFileImage className='text-3xl text-primary' /> */}
                        </Link> :
                        item?.fileType?.includes('video') ?
                            <Link href={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} target="_blank" rel="noreferrer" className="flex items-center justify-center w-full h-full aspect-square overflow-hidden">
                                {/* <FaFileVideo className='text-3xl text-primary' /> */}
                                <video>
                                    <source src={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} type="video/mp4" />
                                    <source src={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} type="video/ogg" />
                                </video>
                            </Link>
                            :
                            item?.fileType?.includes('audio') ?
                                <Link href={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} target="_blank" rel="noreferrer" className="flex items-center justify-center w-full h-full">
                                    <FaFileAudio className='text-3xl text-primary' />
                                </Link>
                                :
                                <Link href={item?.fileUrl ? item?.fileUrl : userDetails?.campaign_path + item?.fileName} target="_blank" rel="noreferrer" className="flex items-center justify-center w-full h-full">
                                    <FaFilePdf className='text-3xl text-red-500' />
                                </Link>
                    }
                </div>
            ))}
        </div>
    )
}

export default OtherAttachments
